import AppServiceClient from './AppServiceClient';

class ClientServiceNewApi extends AppServiceClient {

  authClient(data){
    const headers = {'Content-Type': 'application/x-www-form-urlencoded'}
    return this.http.post('/auth/connect/token', data, {headers: headers})
  }

  getClientById(id){
    const URL = `/auth/v1/clients/${id}`
    return this.http.get(URL)
  }

  getClients(organizationId, pagination, filters){
    let filterString = '&'
    if(filters?.name)filterString = `${filterString}Name=${filters?.name}&`
    if(filterString === '&')filterString = ''
    else filterString = filterString.substring(0, filterString?.length - 1);

    const URL = `/auth/v1/clients?organizationId=${organizationId}&PageNumber=${pagination?.page}&PageSize=${pagination?.size}${filterString}`;
    return this.http.get(URL);
  }
  
  getCompaniesByOrganization(organizationId){
    return this.http.get(`/auth/v1/clients/organization/${organizationId}/companies/available`)
  }
  
  addClient(data) {
    return this.http.post('/auth/v1/clients', data)
  }

}

export default ClientServiceNewApi;
